import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { sendVerificationEmail } from '../../ducks/user.duck';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import { H3, Page, UserNav, LayoutSideNavigation, Icons } from '../../components';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';

import css from './PrivacyPolicyPage.module.css';
import PrivacyPolicyPageContent from './PrivacyPolicyPageContent';

export const PrivacyPolicyPageComponent = props => {
  const { currentUser, scrollingDisabled, intl } = props;

  const title = `${intl.formatMessage({ id: 'PrivacyPolicy.title' })} | Stay Greedless`;
  const description =
    'Read the Stay Greedless privacy policy, including how marketplace data is collected, used, retained, protected, and shared.';

  return (
    <Page title={title} description={description} scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation
        topbar={
          <>
            <TopbarContainer
              currentPage="PrivacyPolicy"
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
              isWhiteBgNav={false}
              isHeaderSticky={true}
            />
            {/* <UserNav currentPage="AboutPage" /> */}
          </>
        }
        hideCssMainClass
        sideNav={null}
        currentPage="PrivacyPolicy"
        footer={<FooterContainer />}
      >
        <PrivacyPolicyPageContent />
      </LayoutSideNavigation>
    </Page>
  );
};

PrivacyPolicyPageComponent.defaultProps = {};

PrivacyPolicyPageComponent.propTypes = {
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  // Topbar needs user info.
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const PrivacyPolicyPage = compose(
  connect(mapStateToProps, null),
  injectIntl
)(PrivacyPolicyPageComponent);

export default PrivacyPolicyPage;
